'use client';
import { useRouter } from 'next/navigation.js';
import { useEffect } from 'react';

import { urlMapping } from '../../../lib/constants.js';
import { doesPlayerHaveLoginAction } from '../../../lib/message-producers/login-server-actions.js';

export default function LoginMessagesHandler(): null {
  const router = useRouter();

  useEffect(() => {
    void (async () => {
      const returnUrl = window.location.pathname;
      const shouldNavigate = await doesPlayerHaveLoginAction(returnUrl);
      if (shouldNavigate) {
        void router.push(`${urlMapping.MEDDELANDE}?returnUrl=${encodeURIComponent(returnUrl)}`);
      }
    })();
  }, []);

  return null;
}
